import React from 'react'
import { useDispatch } from 'react-redux'
import styled from 'styled-components'

import { setSelectedScreenshotId } from '~/actions/screenshots'
import { showScreenshotsSlideshow } from '~/actions/recents'
import Image from '~/components/common/image'
import { Body02 } from '~/components/common/typography'
import { translate } from '~/core/translate'
import MediaBox from '../box/media-box'

const MoreBadge = styled(Body02)`
  background: rgba(0, 0, 0, 0.5);
  border-radius: 4px;
  color: white;
  font-size: 1.875rem;
  left: calc(50% - 18px);
  line-height: 30px;
  padding: 4px 8px;
  position: absolute;
  top: calc(50% - 15px);
`

const Screenshot = ({ className, sessionId, screenshot, showMoreBadge }) => {
  const dispatch = useDispatch()

  const selectScreenshot = () => {
    dispatch(setSelectedScreenshotId({ sessionId, screenshotId: screenshot.objectId }))
    dispatch(showScreenshotsSlideshow(sessionId))
  }

  return (
    <MediaBox
      callback={selectScreenshot}
      className={className}
      aria-label={translate('open_screenshot')}
    >
      <Image alt='' src={screenshot.link} />
      {showMoreBadge && <MoreBadge>+</MoreBadge>}
    </MediaBox>
  )
}

export default Screenshot
